// extracted by mini-css-extract-plugin
module.exports = {"card":"BaseCard_card__hatKP","container":"BaseCard_container__2b7Ml","no-padding":"BaseCard_no-padding__21m3G","notification":"BaseCard_notification__3qa3g"};